var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 19.8723C20.6237 20.2858 20.2888 20.6208 19.8752 20.6221H14.625V16.6875C14.625 12.75 9.375 12.75 9.375 16.6875V20.6221H4.1248C3.71122 20.6208 3.37626 20.2858 3.375 19.8723V10.2721C3.38827 10.0379 3.49189 9.81803 3.66403 9.65874L12 3.37207L20.336 9.65874C20.5081 9.81803 20.6117 10.0379 20.625 10.2721V19.8723Z",
    stroke: "url(#paint0_radial_8141_29208)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8141_29208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9548 25.1416) rotate(-134.873) scale(35.7329 121.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1201f29994363b7cd9a60eef6a30a31f.svg";
export { ForwardRef as ReactComponent };